@if (data) {
  @switch (data.layout) {
    @case (layout.LAYOUT1) {
      <app-form-layout-1></app-form-layout-1>
    }
    @case (layout.LAYOUT1_SUCCESS) {
      <app-form-layout-1-success></app-form-layout-1-success>
    }
    @case (layout.LAYOUT2) {
      <app-form-layout-2></app-form-layout-2>
    }
    @case (layout.LAYOUT2_SUCCESS) {
      <app-form-layout-2-success></app-form-layout-2-success>
    }
    @case (layout.LAYOUT3) {
      <app-form-layout-3></app-form-layout-3>
    }
    @case (layout.LAYOUT3_SUCCESS) {
      <app-form-layout-3-success></app-form-layout-3-success>
    }
    @case (layout.LAYOUT4) {
      <app-form-layout-4></app-form-layout-4>
    }
  }
}
